/**
 * @desc 批量获取文件详情
 */
import {
  OssFileDetail,
  OssDetailBatchParam
} from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryFileDetailBatchParameter = OssDetailBatchParam

const method = 'GET'
const url = '/nexus/oss/detail/batch'

export const queryFileDetailBatchApi = (
  params?: QueryFileDetailBatchParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<OssFileDetail>>({
    method,
    url,
    params,
    ...config
  })
}

queryFileDetailBatchApi.method = method
queryFileDetailBatchApi.url = url
